import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type UnsavedChangesResult = 'save' | 'discard' | 'cancel';

@Component({
  selector: 'app-ui-unsaved-changes-dialog',
  templateUrl: './ui-unsaved-changes-dialog.component.html',
  styleUrls: ['./ui-unsaved-changes-dialog.component.scss']
})
export class UiUnsavedChangesDialogComponent {
  constructor(private dialogRef: MatDialogRef<UiUnsavedChangesDialogComponent>) {}

  choose(result: UnsavedChangesResult): void {
    this.dialogRef.close(result);
  }
}
